export default [
  {
    name: 'add-columns',
    icon: 'fa-columns',
    method: null,
    classes: [],
    hoverable: true,
    menu: 'row-columns-menu',
  },
  {
    name: 'move',
    icon: 'fa-arrows-alt',
    method: null,
    classes: ['row-handle'],
    hoverable: false,
    menu: null,
  },
  {
    name: 'delete',
    icon: 'fa-trash-alt',
    method: 'removeParent',
    classes: [],
    hoverable: false,
    menu: null,
  },
  {
    name: 'settings',
    icon: 'fa-cog',
    method: 'openMenu',
    classes: [],
    hoverable: true,
    menu: 'row-menu',
  }
]